import { HTTP_INTERCEPTORS, HttpInterceptor } from '@angular/common/http';
import { InjectionToken } from '@angular/core';

import { ErrorHandlerHttpInterceptor } from './error-handler.http-interceptor';
import { AuthHttpInterceptor } from './auth.http-interceptor';

export const HttpInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS as InjectionToken<HttpInterceptor>, useClass: ErrorHandlerHttpInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS as InjectionToken<HttpInterceptor>, useClass: AuthHttpInterceptor, multi: true }
];
